// Add your custom JS here.
(function($){
  $(function(){

    var $form    = $('#commentform');
    if (!$form.length) return;

    var $author  = $form.find('input[name="author"]');
    var $email   = $form.find('input[name="email"]');
    var $comment = $form.find('textarea[name="comment"]');
    var $submit  = $form.find('input[type="submit"], button[type="submit"]');

    // Config: allow filtering as user types (true) or just validate (false)
    var FILTER_ON_INPUT = false;

    // Patterns
    // Latin letters (including many accented) + spaces only
    var lettersAndSpaces = /^[A-Za-zÀ-ÖØ-öø-ÿ\s]+$/;
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Helper messages
    var MSG_LETTERS = 'Only letters and spaces are allowed.';
    var MSG_EMAIL   = 'Please enter a valid email address.';
    var MSG_REQUIRED= 'This field is required.';

    function clearVisualError($field) {
      $field.removeClass('comment-field-error');
      $field.siblings('.comment-error-msg').remove();
      // Clear native message
      var el = $field.get(0);
      if (el) el.setCustomValidity('');
    }

    function showVisualError($field, message) {
      $field.addClass('comment-field-error');
      $field.siblings('.comment-error-msg').remove();
      $('<span class="comment-error-msg"></span>').text(message).insertAfter($field);

      // Native block
      var el = $field.get(0);
      if (el) {
        el.setCustomValidity(message);
      }
    }

    function validateAuthor() {
      if (!$author.length) return true;
      var val = ($author.val() || '').trim();
      clearVisualError($author);

      if (!val) {
        showVisualError($author, MSG_REQUIRED);
        return false;
      }
      if (!lettersAndSpaces.test(val)) {
        showVisualError($author, MSG_LETTERS);
        return false;
      }
      return true;
    }

    function validateEmail() {
      if (!$email.length) return true;
      var val = ($email.val() || '').trim();
      clearVisualError($email);

      if (!val) {
        showVisualError($email, MSG_REQUIRED);
        return false;
      }
      if (!emailPattern.test(val)) {
        showVisualError($email, MSG_EMAIL);
        return false;
      }
      return true;
    }

    function validateComment() {
      if (!$comment.length) return true;
      var val = ($comment.val() || '').trim();
      clearVisualError($comment);

      if (!val) {
        showVisualError($comment, MSG_REQUIRED);
        return false;
      }
      if (!lettersAndSpaces.test(val)) {
        showVisualError($comment, 'Comment can contain only letters and spaces.');
        return false;
      }
      return true;
    }

    function validateAll() {
      // Reset custom validity first so reportValidity shows the latest
      [$author, $email, $comment].forEach(function($f){
        if ($f && $f.length) {
          var el = $f.get(0);
          if (el) el.setCustomValidity('');
        }
      });

      var okA = validateAuthor();
      var okE = validateEmail();
      var okC = validateComment();
      return okA && okE && okC;
    }

    // Optional: filter invalid characters while typing
    if (FILTER_ON_INPUT) {
      var filterLettersSpaces = function(str) {
        // Keep only letters/spaces that match our pattern by removing anything else
        return (str || '').replace(/[^A-Za-zÀ-ÖØ-öø-ÿ\s]/g, '');
      };
      $author.on('input', function(){
        var cur = $(this).val();
        var filtered = filterLettersSpaces(cur);
        if (cur !== filtered) {
          $(this).val(filtered);
        }
        clearVisualError($(this));
      });
      $comment.on('input', function(){
        var cur = $(this).val();
        var filtered = filterLettersSpaces(cur);
        if (cur !== filtered) {
          $(this).val(filtered);
        }
        clearVisualError($(this));
      });
      $email.on('input', function(){
        clearVisualError($(this));
      });
    } else {
      // Clear errors as user edits
      $form.on('input', 'input, textarea', function(){
        clearVisualError($(this));
        // also clear native message so browser re-evaluates
        var el = this;
        if (el && typeof el.setCustomValidity === 'function') el.setCustomValidity('');
      });
    }

    // Critical: prevent submission at the earliest event
    // 1) Intercept submit
    $form.on('submit', function(e){
      var valid = validateAll();
      if (!valid) {
        e.preventDefault();
        // Use native reportValidity to show browser messages
        if (this.reportValidity) this.reportValidity();
        // Scroll to first error for UX
        var $first = $form.find('.comment-field-error').first();
        if ($first.length) {
          $('html, body').stop(true).animate({ scrollTop: $first.offset().top - 120 }, 250);
        }
      }
    });

    // 2) Intercept click on submit to block before form tries to submit
    $submit.on('click', function(e){
      var valid = validateAll();
      if (!valid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if ($form.get(0) && $form.get(0).reportValidity) $form.get(0).reportValidity();
      }
    });

    // Ensure HTML5 validation is active (remove novalidate if present)
    $form.removeAttr('novalidate');

    // As a last resort, disable the submit button while invalid (live)
    function toggleSubmit() {
      var valid = validateAll();
      $submit.prop('disabled', !valid);
      if (!valid) {
        // do not lock permanently; re-enable on input events
      }
    }
    // Optional: enable live disabling
    // toggleSubmit();
    // $form.on('input change', 'input, textarea', toggleSubmit);

  });
})(jQuery);